import React from 'react';
import PropTypes from 'prop-types';
import * as echarts from 'echarts';
import ReactEcharts from 'echarts-for-react';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';

const BarChart = ({ data, legendTitle, unitName }) => {
  const isMobile = useMediaQuery({ maxWidth: 900 });
  const { t } = useTranslation(['translation']);
  const total = data.reduce((acc, cv) => acc + cv.value, 0);
  const generateTooltipText = ({ value }) => {
    return `
      ${t('COMMON.INTL_NUMBER', { value })} ${unitName} <br/>
      ${t('COMMON.INTL_PERCENT', { value: total ? value / total : 0 })}`
  };

  const options = {
    legend: {
      data: [{
        name: legendTitle,
        icon: 'rect',
        textStyle: {
          color: '#666C6F',
          fontSize: 15,
        },
      }],
    },
    backgroundColor: 'white',
    xAxis: [{
      type: 'category',
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: '#BDC3C7',
        fontSize: 12,
        fontWeight: 'bold',
      },
      data: data.map(el => el.name),
    }],
    yAxis: [{
      type: 'value',
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: '#BDC3C7',
        fontSize: 12,
        fontWeight: 'bold',
      },
      splitLine: {
        show: false,
      },
      minInterval: 1,
    }],
    tooltip: {
      backgroundColor: 'rgba(50,50,50,0.7)',
      trigger: 'item',
      position: 'top',
      formatter: generateTooltipText,
      textStyle: {
        color: 'white',
        fontSize: 16,
        fontWeight: 300,
        textAlign: 'center',
        align: 'center',
      },
    },
    dataZoom: {
      type: 'inside',
    },
    series: {
      name: legendTitle,
      type: 'bar',
      barWidth: '80%',
      data,
      itemStyle: {
        normal: {
          color: new echarts.graphic.LinearGradient(
            0, 0, 0, 1,
            [{ offset: 0, color: '#38526B' }, { offset: 1, color: '#102131' }],
          ),
        },
        emphasis: {
          color: new echarts.graphic.LinearGradient(
            0, 0, 0, 1,
            [{ offset: 0, color: '#C8D8E1' }, { offset: 1, color: '#AABAC5' }],
          ),
        },
      },
    },
    grid: {
      left: isMobile ? '20%' : '10%',
    },
  };

  return (
    <ReactEcharts
      option={options}
      notMerge
      theme="dark"
      style={{ width: '100%', height: '100%' }}
    />
  );
};

BarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
  })).isRequired,
  legendTitle: PropTypes.string.isRequired,
  unitName: PropTypes.string.isRequired,
};

export default BarChart;
